module.exports = __webpack_public_path__ + "static/media/cedula-azul-ejemplo.8eaace34.png";